import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';
import { TitleLarge500, TitleXLarge500 } from '@nebula/global-styles';
import { useMediaQuery } from '@nebula/hooks';
import { FamilyName } from '../constants.ts';
import { PaymentContext } from '../../PaymentOrchestrator/PaymentContextProvider';

const HeadingText = ({ isTrial, familyType, actionOverride, isDeferredMovement }) => {
  const theme = useContext(ThemeContext);
  const { isRestart } = useContext(PaymentContext) || {};
  const isDesktop = useMediaQuery(theme.media.smallDesktopMin);
  const ProductName = isDesktop ? TitleXLarge500 : TitleLarge500;

  const productElement = <ProductName as="span">{FamilyName[familyType]}</ProductName>;

  if (isTrial) {
    return <React.Fragment>Get your free 30 day trial of {productElement}</React.Fragment>;
  }

  const actionText = actionOverride || (isRestart ? 'Restart' : 'Join');
  return (
    <React.Fragment>
      {actionText} {productElement}
      {!isDeferredMovement && ' today'}
    </React.Fragment>
  );
};

HeadingText.propTypes = {
  isTrial: PropTypes.bool.isRequired,
  familyType: PropTypes.string.isRequired,
  actionOverride: PropTypes.string,
  isDeferredMovement: PropTypes.bool,
};

export default HeadingText;
